import React, { useEffect, useState } from "react";
import Fotter from "./Fotter";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import Cookies from "js-cookie";
import { BASE_URL } from "../Pages/Config";
import { formatDistanceToNow } from "date-fns";

export default function SettingNotification() {
  const [notification, setNotification] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = async () => {
    const user_id = Cookies.get("user_id");

    try {
      setLoading(true);

      const res = await fetch(
        `${BASE_URL}/get_notification.php?user_id=${user_id}&t=${Date.now()}`,
        { cache: "no-store" }
      );

      //  console.log("notify :", res);
      const text = await res.text();
      //    console.log("Raw response:", text);
      // Only parse if not empty
      if (text) {
        const data = JSON.parse(text);
        if (data.success) {
          setNotification(data.data);
        } else {
          console.log("Error:", data.message);
        }
        setLoading(false);
      } else {
        console.warn("Server returned empty response");
        setLoading(false);
      }
    } catch (err) {
      console.error("Fetch failed:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    // Call once immediately
    fetchNotifications();

    // Then call every 7 seconds
    const interval = setInterval(() => {
      fetchNotifications();
    }, 7000); // 7000 ms = 7 seconds

    // Cleanup interval when component unmounts
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const updateNotifications = async () => {
      const user_id = Cookies.get("user_id");

      try {
        const res = await fetch(
          `${BASE_URL}/mark_seen_notification.php?user_id=${user_id}&t=${Date.now()}`,
          { cache: "no-store" }
        );

        // console.log(res);
        if (res.success) {
          // console.log("Notification  Updated !");
        } else {
          //console.log("Error:", res.message);
        }
      } catch (err) {
        console.error("Invalid JSON:", err);
      }
    };

    updateNotifications();
  }, []);

  return (
    <>
      <Navbar />
      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>
                <p>NOTIFICATION</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-sm-12 col-md-12 col-lg-9 col-xl-9">
              <div
                className="setting-info"
                style={{ backgroundColor: " #ffffff00", padding: "0px" }}
              >
                <div className="col-12">
                  {notification.length == 0 ? (
                    <div
                      key="loading"
                      className="loading-overlay"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "550px",
                      }}
                    >
                      <div className="dot-spinner">
                        {[...Array(8)].map((_, i) => (
                          <div key={i} className="dot-spinner__dot"></div>
                        ))}
                      </div>
                    </div>
                  ) : notification.length > 0 ? (
                    notification.map((item, index) => (
                      <Link
                        to={item.item_id == 0 ? "" : `/detail/${item.item_id}`}
                        className="notifiy"
                        key={index}
                        style={{
                          width: "100%",
                          padding: "0",
                          pointerEvents: item.item_id === 0 ? "none" : "auto",
                          color: item.item_id === 0 ? "gray" : "inherit",
                          backgroundColor: "#ffffffc4",
                        }}
                      >
                        <div
                          className="notification-img noti_img"
                          style={{
                            width: "10%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={`./icon.png`}
                            alt=""
                            style={{
                              background: "white",
                              borderRadius: "50%",
                              padding: "5px",
                              marginLeft: "5px",
                            }}
                          />
                        </div>
                        <div
                          className="notify-mass"
                          style={{
                            width: "90%",
                            padding: "5px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <div className="notify-title">
                            <b
                              style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                marginBottom: 0,
                                height: "25px",
                              }}
                            >
                              {item.title}
                            </b>

                            <p style={{ margin: "0", fontSize: "13px" }}>
                              {formatDistanceToNow(new Date(item.date + "Z"), {
                                addSuffix: true,
                                includeSeconds: true,
                              }).replace("about ", "")}
                            </p>
                          </div>
                          <div
                            className="massage"
                            style={{ justifyContent: "start" }}
                          >
                            <p style={{ margin: "0", fontSize: "12px" }}>
                              {item.mass}
                            </p>
                          </div>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <>
                      <img
                        src="./logo/datanotfound.avif"
                        alt="Example"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "contain",
                        }}
                      />
                      <p
                        style={{
                          fontSize: "25px",
                          textAlign: "center",
                          fontWeight: "900",
                        }}
                      >
                        No Data Found
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Fotter />
    </>
  );
}
